function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefe03"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefe03"] = parcelRequire;
}
parcelRequire.register("9wJdH", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $6efa2df7948f6795$export$6503ec6e8aabbaf; }, function (v) { return $6efa2df7948f6795$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $6efa2df7948f6795$export$f7ad0328861e2f03; }, function (v) { return $6efa2df7948f6795$export$f7ad0328861e2f03 = v; });
var $6efa2df7948f6795$export$6503ec6e8aabbaf;
var $6efa2df7948f6795$export$f7ad0328861e2f03;
"use strict";
var $6efa2df7948f6795$var$mapping = {};
function $6efa2df7948f6795$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$6efa2df7948f6795$var$mapping[keys[i]] = pairs[keys[i]];
}
function $6efa2df7948f6795$var$resolve(id) {
    var resolved = $6efa2df7948f6795$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$6efa2df7948f6795$export$6503ec6e8aabbaf = $6efa2df7948f6795$var$register;
$6efa2df7948f6795$export$f7ad0328861e2f03 = $6efa2df7948f6795$var$resolve;

});

var $7af579c84a9ea42d$exports = {};

(parcelRequire("9wJdH")).register(JSON.parse('{"kSOE2":"index.e5f8ccdf.js","4c3lO":"Food Fire Logo.feaf9db9.png","3E9nq":"no-merchant.7b9775f8.png","6kI4j":"no-internet-connection.e9eed014.png","fRZXW":"burger-image.ec55d069.png","5fcce":"contact us.18f23168.png","JTucj":"something-went-wrong.cd185837.png","uZODB":"sorry-no-item-found.1363f7c8.png","3cDMP":"instamart.69607277.js"}'));


//# sourceMappingURL=index.99a56b83.js.map
